import { useQuery } from 'react-query';
import { Contact } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { QueryOptions } from 'v2/queries/types';

interface IUseContactParams extends QueryOptions<Contact> {
  id: number;
}

export const getContactQueryKey = (id: number) => ['Contact', id];

export const useContact = ({
  id,
  enabled = true,
  retry = 3,
  refetchOnWindowFocus = true,
  cacheTime,
}: IUseContactParams) => {
  return useQuery(
    getContactQueryKey(id),
    () => restFactory.get<Contact>(`/dj/api/v1/contact/${id}`),
    {
      enabled,
      retry,
      refetchOnWindowFocus,
      cacheTime,
    }
  );
};
